import { Module } from '@nestjs/common';
import { PrismaModule } from 'src/prisma/prisma.module';
import { winstonConfig } from '../common/logger/winston.config';
import { PlanesController } from './planes.controller';
import { PlanesService } from './planes.service';

@Module({
  imports: [PrismaModule],
  controllers: [PlanesController],
  providers: [PlanesService],
  exports: [PlanesService],
})
export class PlanesModule {}
